<div class="view-register__main">
    <div class="view-register-section">
        <div class="view-register-management-section">
            <app-list-page-header [headerTitle]="(materialList?.shipmentType || '') + ' ' + (materialList?.scrapType || '')">
            </app-list-page-header>
        <div *ngIf="!isModal">
            <app-common-button buttonClass="smallbutton" (clickEvent)="back()" buttonLabel="Back">
            </app-common-button>
        </div>
        <div *ngIf="isModal">
            <app-common-icon [faIcon]="faDownload" [ngbTooltip]="'Download'" [placement]="'bottom'" class="downloadButton"
                (clickEvent)="downloadSheet()" [loadingIcon]="loadingRecords">
            </app-common-icon>
        </div>
        </div>
        <div>
            <div class="view-register-details__detailscard">
                <div class="viewcontractDetail d-flex justify-content-between align-items-center search-by w-100">
                    <div class="view-register-details__detailscardfield">
                        <div class="view-register-details__detailscardfield-description mb-2">
                            Unique ID
                        </div>
                        <div class="view-register-details__detailscardfieldheading">
                            {{ materialList?.uniqueId }}
                        </div>
                    </div>
                    <div class="view-register-details__detailscardfield">
                        <div class="view-register-details__detailscardfield-description mb-2">
                            Scrap Type
                        </div>
                        <div class="view-register-details__detailscardfieldheading">
                            {{ materialList?.scrapType }}
                        </div>
                    </div>
                    <div class="view-register-details__detailscardfield">
                        <div class="view-register-details__detailscardfield-description mb-2">
                            Status
                        </div>
                        <div class="view-register-details__detailscardfieldheading"
                            [ngStyle]="getStatusStyle(materialList?.status)">
                            {{ materialList?.status }}
                        </div>
                    </div>
                    <div class="d-flex text-right" *ngIf="!isModal">
                        <div (click)="isEdit()">
                            <app-common-icon [faIcon]="faPen" [placement]="'top'"  appAccessControl
                                allowedRoles="mr-scrap.update"
                                *ngIf="(materialList?.status === 'Pending Document Upload' || materialList?.status === 'Pending Correction') && (!isPrimary && !selectedCompanyId)"
                                class="btn btn-primary btn-sm me-2 custom-disable" ngbTooltip="Edit"></app-common-icon>
                        </div>
                        <div (click)="isUploadDocument()">
                            <app-common-icon [faIcon]="faCloudUploadAlt" [placement]="'top'" appAccessControl
                                allowedRoles="mr-scrap.upload"
                                *ngIf="(materialList?.status === 'Pending Document Upload') && (!isPrimary && !selectedCompanyId)"
                                class="btn btn-primary btn-sm me-2 custom-disable"
                                ngbTooltip="Upload"></app-common-icon>
                        </div>
                    </div>
                </div>
            </div>
            <div class="view-register-details__DescriptionWrapper">
                <div class="view-register-details__DescriptionContainer">
                    <div class="d-flex justify-content-between border-bottom">
                        <div class="view-register-details__DescriptionHeader mb-2">
                           Work Approval Numbers
                            <span *ngIf="materialList?.approvalNo?.length > 0">({{materialList?.approvalNo?.length}})</span>
                        </div>
                    </div>
                    <div class="view-approval-details">
                        <div class="view-register-details__detailscardfield">
                            <p class="view-register-details__detailscardfieldheading ms-3 uppercase-text">
                                {{ materialList?.approvalNo?.join(' | ') }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="view-register-details__DescriptionWrapper">
                <div class="view-register-details__DescriptionContainer">
                    <div class="d-flex justify-content-between border-bottom">
                        <div class="view-register-details__DescriptionHeader mb-2">
                            Truck Numbers
                            <span *ngIf="materialList?.truckNumber?.length > 0">({{materialList?.truckNumber?.length}})</span>
                        </div>
                    </div>
                    <div class="view-approval-details">
                        <div class="view-register-details__detailscardfield">
                            <p class="view-register-details__detailscardfieldheading ms-3 uppercase-text">
                                {{ materialList?.truckNumber?.join(' | ') }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="view-register-details__DescriptionWrapper">
                <div class="view-register-details__DescriptionContainer">
                    <div class="d-flex justify-content-between border-bottom">
                        <div class="view-register-details__DescriptionHeader mb-2">
                            Scrap Details
                        </div>
                    </div>
                    <div class="view-register-details__table">
                        <div class="view-register-details__row header">
                            <div class="view-register-details__detailscardfield-description">Scrap Buyer Name</div>
                            <div class="view-register-details__detailscardfield-description">EwayBill</div>
                            <div class="view-register-details__detailscardfield-description">Tax Invoice Number</div>
                            <div class="view-register-details__detailscardfield-description">Invoice Date</div>
                            <div class="view-register-details__detailscardfield-description">Total Weight</div>
                        </div>
                        <div *ngFor="let scrap of materialList?.scrapData"  class="view-register-details__row">
                            <div class="view-register-details__detailscardfieldheading">
                                <span class="view-register-details__detailscardfieldheading uppercase-text"
                                    *ngFor="let buyer of scrap.scrapBuyer; let last = last">
                                    {{ buyer }} <br *ngIf="!last">
                                </span>
                            </div>
                            <div class="view-register-details__detailscardfieldheading">
                                <span class="view-register-details__detailscardfieldheading uppercase-text"
                                    *ngFor="let eway of scrap.eWayBill; let last = last">
                                    {{ eway }} <br *ngIf="!last">
                                </span>
                            </div>    
                            <div class="view-register-details__detailscardfieldheading">
                                <span class="view-register-details__detailscardfieldheading uppercase-text"
                                    *ngFor="let invoice of scrap.taxInvoiceNo; let last = last">
                                    {{ invoice }} <br *ngIf="!last">
                                </span>
                            </div>
                            <div class="view-register-details__detailscardfieldheading">
                                <span class="view-register-details__detailscardfieldheading uppercase-text"
                                    *ngFor="let date of scrap.invoiceDate; let last = last">
                                    {{ date | date:"dd-MMM-yy" }} <br *ngIf="!last">
                                </span>
                            </div>
                            <div class="view-register-details__detailscardfieldheading uppercase-text">
                                {{ scrap.weighment }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="view-register-details__DescriptionWrapper">
                <div class="view-register-details__DescriptionContainer">
                    <div class="row d-flex justify-content-between border-bottom">
                        <div class="col-md-5 view-register-details__DescriptionHeader mb-2">
                            Uploaded Documents
                        </div>
                        <div class="col-md-7">
                            Material Register Logs
                        </div>
                    </div>

                    <div class="ownership-document document-container">
                        <div class="toolbar" *ngIf="fileDetails && materialList?.status !== 'Pending Document Upload'">
                            <button (click)="downloadDocument()" *ngIf="!isLoading && !isModal">
                                <fa-icon [icon]="faDownload"></fa-icon>
                            </button>
                             <button disabled *ngIf="isLoading && !isModal">
                                <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
                            </button>
                            <button (click)="openDocumentPopup()" *ngIf="!isModal">
                                <fa-icon [icon]="faExpand"></fa-icon>
                            </button>
                        </div>
                        <ng-container *ngIf="fileDetails && materialList?.status !== 'Pending Document Upload'; else noFileMessage">
                            <div class="ownership-document--body">
                                <ng-container *ngIf="materialList.isImage && !materialList.isTiff; else otherFile">
                                    <img [src]="materialList.documentThumbnailUrl ? materialList.documentThumbnailUrl : '../../../assets/Images/document-preview/Files.svg'" alt="Document Preview"
                                        class="ownership-document--body__Image">
                                </ng-container>
                                <ng-template #otherFile>
                                    <img [src]="fileDetails.thumbnailUrl ? fileDetails.thumbnailUrl : '../../../assets/Images/document-preview/Files.svg'"
                                        alt="Document Thumbnail" class="ownership-document--body__Image">
                                </ng-template>
                                <p class="document-info--container__Desc file_name">{{ fileDetails?.name }}</p>
                            </div>
                        </ng-container>
                        <ng-template #noFileMessage>
                            <div class="ownership-document--body">
                                <p class="no-file text-danger">File is yet to upload</p>
                            </div>
                        </ng-template>
                        <section class="auditLog_view">
                            <div class="esign-info" infiniteScroll [infiniteScrollDistance]="0" [scrollWindow]="false"
                            [infiniteScrollThrottle]="500" (scrolled)="onScrolled()">
                            <table class="table" aria-label="eSignDetails">
                                <thead>
                                    <tr>
                                        <th class="document-info--container__Date">Date</th>
                                        <th class="document-info--container__Name">Logs</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of updateHistory">
                                        <td class="document-info--container__Date">
                                            {{item?.created | date:"dd MMM yy, hh:mm a"}}</td>
                                            <ng-container *ngIf="item?.formatedMessage; else normalMessage">
                                                <td class="document-info--container__Name" [innerHTML]="item?.formatedMessage"></td>
                                              </ng-container>
                                              <ng-template #normalMessage>
                                                <td class="document-info--container__Name">
                                                  {{ item?.message }} {{ item?.userDetails.name }}
                                                  <span *ngIf="item?.reason">
                                                    <span class="message">with reason</span> {{ item?.reason }}
                                                  </span>
                                                </td>
                                              </ng-template>                                                                                           
                                    </tr>
                                    <tr *ngIf="!updateHistory || updateHistory.length === 0">
                                        <td class="document-info--container__Name text-center text-danger" colspan="2">
                                            No data found
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        </section>
                    </div>
                </div>
            </div>
            <div class="view-register-details__DescriptionWrapper" *ngIf="materialList?.remarks">
                <div class="view-register-details__DescriptionContainer">
                    <div class="row d-flex justify-content-between border-bottom">
                        <div class="col-md-5 view-register-details__DescriptionHeader mb-2">
                            Remarks
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-12">
                            <p class="view-register-details__detailscardfieldheading remarks-text">
                                {{ materialList?.remarks || '-' }}
                            </p>
                        </div>
                    </div>
                </div>
            </div> 
            <div class="view-register-details__DescriptionWrapper"
            *ngIf="materialList?.status !== 'Pending Document Upload' && materialList?.status !== 'Pending OCR Validation'">                <div class="view-register-details__DescriptionContainer">
                    <div class="d-flex border-bottom">
                        <span class="view-register-details__DescriptionHeader mb-2">
                            Validation Details
                        </span>
                        <p class="note-text">
                            (* Modified fields are highlighted in <span class="note-update">orange</span> color)
                        </p>
                    </div>
                    <div class="update-history">
                        <section class="updated_history_view" *ngIf="materialList?.status === 'Completed' || materialList?.status === 'Pending Correction' || materialList?.status === 'Archive'">
                          <div class="esign-info extract" infiniteScroll [infiniteScrollDistance]="0" [scrollWindow]="false"
                              [infiniteScrollThrottle]="500" (scrolled)="onScrolling()"
                              *ngIf="materialList?.status === 'Completed' || materialList?.status === 'Pending Correction' || materialList?.status === 'Archive'">
                              <table class="table" aria-label="eSignDetails">
                                <thead>
                                    <tr>
                                        <th class="document-info--container__Name" *ngFor="let header of tableData?.headers">{{ header }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let row of tableData.data">
                                      <tr *ngIf="row.isGroupRow" class="group-header-row">
                                        <td class="document-info--container__Name" colspan="6"><strong>{{ row.invoiceNo }}</strong></td>
                                      </tr>
                                      <tr>
                                        <td class="document-info--container__Name"></td>
                                        <td class="document-info--container__Name">{{ row.field || '-' }}</td>
                                        <td class="document-info--container__Name" [ngClass]="{'update' : row.isUpdated === true}">{{ row.expected || '-' }}</td>
                                        <td class="document-info--container__Name">{{ row.extracted || '-' }}</td>
                                        <td class="document-info--container__Name">{{ row.pageNumber || '-' }}</td>
                                        <td class="document-info--container__Name" [ngClass]="{
                                            'status-pass': row.status === 'Match' && row.expected !== ' - ' && row.extracted !== ' - ',
                                            'status-fail': row.status === 'Mismatch'
                                          }">
                                            {{ row.status || ' - ' }}
                                          </td>
                                     </tr>
                                    </ng-container>
                                  </tbody>
                                  
                            </table>
                          </div>
                      </section>
                  </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-material-upload *ngIf="isUploadDocuments" (successMessage)="onUploadSuccess($event)" [materialData]="selectedMaterial" (closeOverlay)="closeUploadOverlay()"></app-material-upload>
<ng-template #documentModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">Document Preview</h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body modal-container">
        <div class="document-preview">
            <iframe title="error message" *ngIf="materialList?.isPdf && !loader" [src]="materialList.documentThumbnailUrl" class="document-frame">
                This browser does not support PDFs. <a [href]="materialList.documentThumbnailUrl" target="_blank">Download PDF</a>
            </iframe>

            <img *ngIf="!materialList?.isPdf && materialList?.documentThumbnailUrl && !loader"
                [src]="materialList.documentThumbnailUrl" alt="Document Preview" class="document-image" />

                <div *ngIf="!materialList?.documentThumbnailUrl && !loader" class="no-preview">
                    <img src="../../../assets/Images/document-preview/Files.svg" class="ownership-document--body__Image" alt="Default Document Icon">
                    <p class="document-info--container__Desc file_name">No preview available</p>
                </div>
                <div *ngIf="loader" class="text-danger loader">
                    <fa-icon [icon]="faSpinner" animation="spin"></fa-icon>
                </div>
        </div>

        <div class="document-info">
            <div>
                <div class="document-info--container">
                    <div class="document-info--container__Name">Name</div>
                    <div class="document-info--container__Desc" data-bs-toggle="tooltip" placement="top">
                        <span class="span-space">: </span>{{fileDetails?.name}}
                    </div>
                </div>
                <div class="document-info--container">
                    <div class="document-info--container__Name">Total Size</div>
                    <div class="document-info--container__Desc"><span class="span-space">: </span>{{(this.fileDetails?.fileSize | storageFormat)}}</div>
                </div>
                <div class="document-info--container">
                    <div class="document-info--container__Name">File Type</div>&nbsp;
                    <div class="document-info--container__Desc"><span class="span-space">: </span>{{getFileType(fileDetails?.mimeType)}}</div>
                </div>
            </div>
            <br>
            <section>
                <div class="audit-information">Audit Log</div>
                <br>
                <div class="esign-info" infiniteScroll [infiniteScrollDistance]="0" [scrollWindow]="false"
                    [infiniteScrollThrottle]="500" (scrolled)="onScroll()">
                    <table class="table" aria-label="eSignDetails">
                        <thead>
                            <tr>
                                <th class="document-info--container__Name">Date</th>
                                <th class="document-info--container__Name">Logs</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of inboundLog">
                                <td class="document-info--container__Name">
                                    {{item?.created | date:"dd MMM yy, hh:mm a"}}</td>
                                <td class="document-info--container__Name">{{item?.message}}
                                    {{item?.userDetails.name}}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    </div>
</ng-template>
<div  *ngIf="isSuccessToster">
    <app-toast [title]="message" (closeToaster)="closeToster($event)"></app-toast>
</div>
<div *ngIf="isErrorToster">
  <app-error-toaster [title]="errorMessage" (closeToaster)="closeToster($event)"></app-error-toaster>
</div>
